module.exports = __webpack_public_path__ + "img/bg_signup.19776170.svg";